<template>
  <div>
    <div class="card">
      <div class="card-header card-header-flex mt-3">
        <div class="d-flex flex-column justify-content-center mr-auto">
          <h5 class="mb-0">
            {{ $t('reports.common.searching_period') }}: {{ searching_period[0].format('DD MMMM YYYY') }} - {{ searching_period[1].format('DD MMMM YYYY') }}
          </h5>
        </div>
      </div>
      <div class="card-body">
        <a-table
          :columns="columns"
          :data-source="data"
          :pagination="pagination"
          bordered
          :row-key="record => record.id"
          @change="handleTableChange"
        >
          <div
            slot="filterDropdown"
            slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
            class="custom-filter-dropdown"
          >
            <a-input
              :placeholder="$t('common.search_by') + ` ${column.title}`"
              :value="selectedKeys[0]"
              style="width: 188px; margin-bottom: 8px; display: block;"
              @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
              @pressEnter="() => handleSearch(selectedKeys, confirm)"
            />
            <a-button
              type="primary"
              size="small"
              style="width: 90px; margin-right: 8px"
              @click="() => handleSearch(selectedKeys, confirm)"
            >
              {{ $t('common.search') }}
            </a-button>
            <a-button
              size="small"
              style="width: 90px"
              @click="() => handleReset(clearFilters)"
            >
              {{ $t('common.reset') }}
            </a-button>
          </div>
          <div
            slot="filterDate"
            class="custom-filter-dropdown"
          >
            <!--            slot-scope="{ setSelectedKeys, selectedKeys, confirm }"-->
            <a-range-picker
              v-model="searching_period"
              :show-time="false"
              @change="handleDateFilter"
            >
              <a-icon
                slot="suffixIcon"
                type="smile"
              />
            </a-range-picker>
          </div>
          <a-icon
            slot="filterIcon"
            slot-scope="filtered"
            type="search"
            :style="{ color: filtered ? '#108ee9' : undefined }"
          />

          <template
            slot="seller_company"
            slot-scope="s"
          >
            <router-link
              :to="`/admin/seller/stores/${s.hash_id}`"
              class="btn btn-sm btn-light"
            >
              {{ $l(s.title) }}
            </router-link>
          </template>

          <template
            slot="type"
            slot-scope="text"
          >
            <strong>{{ $l(text) }}</strong>
          </template>

          <template
            slot="payment_type"
            slot-scope="text"
          >
            <span
              v-if="text === 'ONLINE'"
              class="badge mr-2 badge-primary"
            >
              {{ $t('orders.payment_type.online') }}
            </span>
            <span
              v-else
              class="badge mr-2 badge-secondary"
            >
              {{ $t('orders.payment_type.on_premise') }}
            </span>
          </template>

          <template
            slot="money"
            slot-scope="text"
          >
            {{ text | money }}
          </template>

          <template
            slot="payment_time"
            slot-scope="text"
          >
            {{ text | dateFormatter('YYYY-MM-DD HH:mm:ss') }}
          </template>
        </a-table>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { Modal } from 'ant-design-vue'
import reportService from '@/services/api/admin/reports/report-services'

export default {
  name: 'OperationsJournal',
  components: {
  },
  data: function () {
    return {
      searching_period: [moment().startOf('month'), moment().endOf('month')],
      columns: [
        {
          title: this.$t('reports.operations.id'),
          dataIndex: 'id',
          sorter: true,
        },
        {
          title: this.$t('reports.operations.order_id'),
          dataIndex: 'order.id',
          key: 'order_id',
          scopedSlots: { filterDropdown: 'filterDropdown', filterIcon: 'filterIcon' },
        },
        {
          title: this.$t('reports.operations.track_no'),
          dataIndex: 'order.tracking_no',
          key: 'tracking_no',
          scopedSlots: { filterDropdown: 'filterDropdown', filterIcon: 'filterIcon' },
        },
        {
          title: this.$t('reports.operations.seller'),
          dataIndex: 'seller_company',
          scopedSlots: { customRender: 'seller_company', filterDropdown: 'filterDropdown', filterIcon: 'filterIcon' },
        },
        {
          title: this.$t('reports.operations.tin'),
          dataIndex: 'seller_company.tin',
          key: 'tin',
          scopedSlots: { filterDropdown: 'filterDropdown', filterIcon: 'filterIcon' },
        },
        {
          title: this.$t('reports.operations.ext_payment_id'),
          dataIndex: 'ext_payment_id',
          scopedSlots: { filterDropdown: 'filterDropdown', filterIcon: 'filterIcon' },
        },
        {
          title: this.$t('reports.operations.amounts'),
          children: [
            {
              title: this.$t('reports.common.total_cost'),
              dataIndex: 'total_product_cost',
              scopedSlots: { customRender: 'money' },
            },
            {
              title: this.$t('reports.common.delivery_cost'),
              dataIndex: 'delivery_cost',
              scopedSlots: { customRender: 'money' },
            },
            {
              title: this.$t('reports.common.buyer_commission'),
              dataIndex: 'buyer_commission',
              scopedSlots: { customRender: 'money' },
            },
          ],
        },
        {
          title: this.$t('reports.common.payment_type.self'),
          dataIndex: 'payment_type',
          filters: [
            { text: this.$t('orders.payment_type.online'), value: 'ONLINE' },
            { text: this.$t('orders.payment_type.on_premise'), value: 'ON_PREMISE' },
          ],
          scopedSlots: { customRender: 'payment_type' },
        },
        {
          title: this.$t('reports.common.date'),
          dataIndex: 'payment_time',
          sorter: true,
          scopedSlots: { customRender: 'payment_time', filterDropdown: 'filterDate' },
        },
      ],
      data: [],
      pagination: {
        total: 0,
        current: 1,
        pageSize: 10,
      },
      filter: {
        title: '',
      },
      sorting: {
        col: 'id',
        order: 'desc',
      },
    }
  },
  mounted() {
    this.fetchData()
  },
  methods: {
    showRegenerationResult(count) {
      Modal.success({
        title: this.$i18n.t('product_add.messages.regeneration_result'),
        content: count + '' + this.$i18n.t('product_add.messages.regeneration_result_count'),
      })
    },
    fetchData() {
      this.filter.date_from = this.searching_period[0].format('YYYY-MM-DD')
      this.filter.date_to = this.searching_period[1].format('YYYY-MM-DD')
      reportService.getOperations(this.pagination, this.sorting, this.filter)
        .then((response) => {
          if (response && response.data && response.data.content) {
            this.data = response.data.content
            this.pagination.total = response.data.pagination.total
          }
        })
    },
    handleDateFilter(dates, dateStrings) {
      console.log('invoked on change')
      this.searching_period = dates
      this.fetchData()
    },
    handleSearch(selectedKeys, confirm) {
      confirm()
      this.searchText = selectedKeys[0]
    },
    handleReset(clearFilters) {
      clearFilters()
      this.searchText = ''
    },
    handleTableChange(pagination, filter, sorter) {
      if (sorter.columnKey && sorter.order)
        this.sorting = {
          col: sorter.columnKey,
          order: sorter.order.replace('end', ''), // ascend -> asc | descend -> desc
        }
      else
        this.sorting = null

      Object.keys(filter).forEach(key => {
        if (filter[key] && filter[key].length === 1)
          this.filter[key] = filter[key][0]
        else
          this.filter[key] = null
      })

      this.pagination.current = pagination.current

      this.fetchData()
    },
  },
}
</script>
<style>
.seller-table tr td:last-child {
  width: 116px !important;
}
.vertical-center {
  vertical-align: middle !important;
}
</style>
